import React, { useEffect, useRef, useState } from "react";

interface AutoCompleteListInputType {
  fieldName: string;
  placeHolder: string;
  value: string;
  items: Array<string>;
  setSelectedItem: Function;
}

const AutoCompleteListInput: React.FC<AutoCompleteListInputType> = ({
  fieldName,
  value,
  placeHolder,
  items,
  setSelectedItem,
}) => {
  const searchInputRef = useRef(null);

  const [newItem, setNewItem] = useState("");
  const [showList, setShowList] = useState(false);
  const filtered = items.filter((item) => item.toLowerCase().includes(newItem));

  useEffect(() => {
    setNewItem(value);
  }, []);

  return (
    <div className="position-relative">
      <input
        ref={searchInputRef}
        type="text"
        className="form-control"
        placeholder={placeHolder}
        name={fieldName}
        value={newItem}
        autoComplete="off"
        onChange={(e) => {
          const item = e.target.value;

          setNewItem(e.target.value);
          setSelectedItem(item);
        }}
        onFocus={() => {
          setShowList(true);
        }}
        onBlur={() => setTimeout(() => setShowList(false), 100)}
      />

      {showList && filtered.length > 0 && (
        <ul
          style={{
            listStyle: "none",
            padding: "0",
            margin: "0",
            position: "absolute",
            background: "white",
            border: "1px solid #ccc",
            width: "100%",
            zIndex: 10,
            maxHeight: "350px",
            overflowY: "auto",
          }}
        >
          {filtered.map((item: string) => (
            <li
              key={item}
              style={{ padding: "8px", cursor: "pointer" }}
              onMouseDown={() => {
                setSelectedItem(item);
                setNewItem(item);
                setShowList(false);

                searchInputRef.current.blur();
              }}
            >
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AutoCompleteListInput;
